import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/CustomerSearch'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class CustomerSearchStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "CustomerSearchStore",
			variables: false,
		})
	}
}

export async function load_CustomerSearch(params) {
  await initClient()

	const store = new CustomerSearchStore()

	await store.fetch(params)

	return {
		CustomerSearch: store,
	}
}
